<template>
    <v-container class="stripe-callback-page fill-height">
        <v-row class="justify-center align-center">
            <v-col cols="12" sm="8" md="6" lg="4" class="text-center">
                <v-card elevation="0" class="pa-8 callback-card">
                    <!-- Loading State -->
                    <template v-if="isLoading">
                        <v-progress-circular
                            indeterminate
                            color="primary"
                            size="64"
                            class="mb-4"
                        ></v-progress-circular>
                        <h2 class="callback-title mb-2">Completing Setup...</h2>
                        <p class="callback-text">
                            Please wait while we verify your Stripe account.
                        </p>
                    </template>

                    <!-- Error State -->
                    <template v-else-if="hasError">
                        <v-icon size="64" color="error" class="mb-4">mdi-alert-circle</v-icon>
                        <h2 class="callback-title mb-2">Something Went Wrong</h2>
                        <p class="callback-text mb-4">
                            {{ errorMessage }}
                        </p>
                        <v-btn color="primary" depressed @click="goToLogin">
                            Sign In Again
                        </v-btn>
                    </template>

                    <!-- Success State (brief, before redirect) -->
                    <template v-else>
                        <v-icon size="64" color="success" class="mb-4">mdi-check-circle</v-icon>
                        <h2 class="callback-title mb-2">Stripe Connected!</h2>
                        <p class="callback-text">
                            Redirecting you to My Campaign...
                        </p>
                    </template>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { TokenService } from '@/services/storage.service'

export default {
    name: 'StripeCallback',
    data() {
        return {
            isLoading: true,
            hasError: false,
            errorMessage: ''
        }
    },
    methods: {
        async verifyAndRedirect() {
            // Check if we have a token
            const token = TokenService.getToken()

            if (!token) {
                this.isLoading = false
                this.hasError = true
                this.errorMessage = 'Your session has expired. Please sign in again to continue.'
                return
            }

            try {
                // Refresh user data from API
                await this.$store.dispatch('getUserByToken')

                // Brief success state before redirect
                this.isLoading = false

                // Small delay to show success message
                setTimeout(() => {
                    this.$router.push('/campaign')
                }, 1000)
            } catch (error) {
                this.isLoading = false
                this.hasError = true
                this.errorMessage = 'We could not verify your session. Please sign in again.'
            }
        },
        goToLogin() {
            // Clear any stale tokens
            TokenService.removeToken()
            this.$store.commit('setUser', {})
            this.$store.commit('setIsUserLoggedIn', false)

            // Redirect to home (which has the login)
            this.$router.push('/')
        }
    },
    mounted() {
        this.verifyAndRedirect()
    }
}
</script>

<style scoped>
.stripe-callback-page {
    min-height: 100vh;
    background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
}

.callback-card {
    border-radius: 12px !important;
}

.callback-title {
    font-size: 24px;
    font-weight: 700;
    color: #333;
}

.callback-text {
    font-size: 16px;
    color: #666;
    margin: 0;
}
</style>
